/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Role update data
 * @export
 * @interface UpdateRoleRequest
 */
export interface UpdateRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleRequest
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleRequest
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRoleRequest
     */
    permissions?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRoleRequest
     */
    active?: boolean;
}

/**
 * Check if a given object implements the UpdateRoleRequest interface.
 */
export function instanceOfUpdateRoleRequest(value: object): value is UpdateRoleRequest {
    return true;
}

export function UpdateRoleRequestFromJSON(json: any): UpdateRoleRequest {
    return UpdateRoleRequestFromJSONTyped(json, false);
}

export function UpdateRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRoleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'displayName': json['display_name'] == null ? undefined : json['display_name'],
        'description': json['description'] == null ? undefined : json['description'],
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function UpdateRoleRequestToJSON(json: any): UpdateRoleRequest {
    return UpdateRoleRequestToJSONTyped(json, false);
}

export function UpdateRoleRequestToJSONTyped(value?: UpdateRoleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'display_name': value['displayName'],
        'description': value['description'],
        'permissions': value['permissions'],
        'active': value['active'],
    };
}

